<div class="catalog-filters" [ngClass]="{'border-radius-2': (isNewPLPVariantRestyle$ | async) && isPLP}" [mmTestId]="'PRODUCT_CATALOG.FILTERS'">
  <h4 class="catalog-filters__title" [ngClass]="{'margin-bottom-8': !(isNewPLPVariantRestyle$ | async) && isPLP,
  'padding20': (isNewPLPVariantRestyle$ | async) && isPLP}" *ngIf="!isMobileOrTablet">
    {{ 'CATALOG.CATALOG_PAGE.FILTERS.TITLE.FILTERS' | translate }}
  </h4>

  <div class="catalog-filters__header" fxLayout="row" fxLayoutAlign="space-between center">
    <h3 class="catalog-filters__header__title">{{ 'CATALOG.CATALOG_PAGE.FILTERS.TITLE.FILTERS' | translate }}</h3>

    <a
      role="button"
      class="catalog-filters__header__close-btn"
      [mmTestTarget]="'close-filters-button'"
      (click)="filterType ? closeAndResetSpecificFilterToPreviousState() : closeAndResetFilterToPreviousState()"
    >
      <mm-icon name="close" class="catalog-filters__close-icon"></mm-icon>
    </a>
  </div>

  <ng-container *ngIf="!filterType; else specificFilters">
    <div
      class="catalog-filters__filter catalog-filter"
      [ngClass]="{'catalog-filter-padding-oldPLP': !(isNewPLPVariantRestyle$ | async) && isPLP}"
      [mmTestTarget]="'filters-container'"
      [mmTestState]="(isFiltersLoading$ | async) ? 'loading' : 'loaded'"
    >
      <ng-container *ngIf="isDesktop && isCategoryPage && categories?.length && isCategoryListFilter">
        <div
          class="catalog-filter__wrapper filter-wrapper subcategories-filter-list"
          [mmTestId]="'FILTERS.CATEGORY_LIST'"
        >
          <mm-expansion
            class="catalog-filter__wrapper__expansion"
            (toggled)="updateFilterCollapseState(filterCollapseStateKeys.CATEGORY_LIST, $event)"
            [expanded]="isFilterCollapseExpanded(filterCollapseStateKeys.CATEGORY_LIST)"
            [arrowToggler]="true"
            [testTarget]="'FILTERS.EXPANSION.TOGGLER'"
          >
            <mm-expansion-title>
              <h4 class="filter-wrapper__title">
                {{ 'CATALOG.CATALOG_PAGE.FILTERS.TITLE.SUBCATEGORIES' | translate }}
              </h4>
            </mm-expansion-title>
            <app-search-category-children-list [categories]="categories"></app-search-category-children-list>
          </mm-expansion>
        </div>
      </ng-container>

      <ng-container *ngIf="(isSearchPage || isCustomPLPPage || isBrandPLPPage) && (!isDesktop || (isDesktop && !(isVariantB$ | async)))">
        <div class="catalog-filter__wrapper filter-wrapper" [mmTestId]="'FILTERS.CATEGORIES'">
          <mm-expansion
            class="catalog-filter__wrapper__expansion"
            (toggled)="updateFilterCollapseState(filterCollapseStateKeys.CATEGORY, $event)"
            [expanded]="isFilterCollapseExpanded(filterCollapseStateKeys.CATEGORY)"
            [arrowToggler]="true"
            [testTarget]="'FILTERS.EXPANSION.TOGGLER'"
          >
            <mm-expansion-title>
              <h4 class="filter-wrapper__title">{{ 'CATALOG.CATALOG_PAGE.FILTERS.TITLE.CATEGORIES' | translate }}</h4>
            </mm-expansion-title>
            <app-search-categories-filters-list
              [categories]="categories"
              [queryParams]="queryParams"
              [selectedCategoriesSlugs]="categoriesFilters$ | async"
              (selectedCategoriesChanged)="filterByCategories($event)"
              [isDesktop]="isDesktop">
            </app-search-categories-filters-list>
            <button
              *ngIf="isCategoryResetButtonShown()"
              mm-button
              class="catalog-filter__wrapper__filter-reset"
              color="secondary"
              [fluid]="true"
              [size]="'small'"
              [mmTestTarget]="'reset-by-filter'"
              (click)="resetCategoryFilter()"
            >
              {{ 'CATALOG.CATALOG_PAGE.FILTERS.RESET' | translate }}
            </button>
          </mm-expansion>
        </div>
        <div class="catalog-filter__wrapper-separator" [ngClass]="{
          'expanded': isFilterCollapseExpanded(filterCollapseStateKeys.CATEGORY)
        }"></div>
      </ng-container>

      <div class="catalog-filter__wrapper filter-wrapper" [mmTestId]="'FILTERS.PRICE'">
        <mm-expansion
          class="catalog-filter__wrapper__expansion price-filter__expansion"
          (toggled)="updateFilterCollapseState(filterCollapseStateKeys.PRICE, $event)"
          [expanded]="isFilterCollapseExpanded(filterCollapseStateKeys.PRICE)"
          [arrowToggler]="true"
          [testTarget]="'FILTERS.EXPANSION.TOGGLER'"
        >
          <mm-expansion-title>
            <div class="title__container">
              <h4 class="filter-wrapper__title">{{ 'CATALOG.CATALOG_PAGE.FILTERS.TITLE.PRICE' | translate }}</h4>
              <app-tooltip *ngIf="isDesktop && (isNewPLPVariantRestyle$ | async)"
                           class="price-filter__tooltip"
                           [position]="tooltipPosition"
                           [fontSize]="11"
                           [height]="14"
                           [width]="14"
                           [bulletIconName]="'icon_question_mark_plain'"
                           [bulletBackgroundColor]="bulletBackgroundColor">
                <p class="price-filter__disclaimer">
                  {{ 'CATALOG.CATALOG_PAGE.FILTERS.PRICE.UNITS.DISCLAIMER' | translate }}
                </p>
              </app-tooltip>
            </div>
          </mm-expansion-title>
          <app-search-price-filter (priceFilterChanged)="filterByPrice($event)"></app-search-price-filter>
          <span *ngIf="!isDesktop && (isNewPLPVariantRestyle$ | async)" class="price-filter__disclaimer-text">
                {{ 'CATALOG.CATALOG_PAGE.FILTERS.PRICE.UNITS.DISCLAIMER' | translate }}
              </span>
        </mm-expansion>
        <div
          class="catalog-filter__wrapper-separator"
          [ngClass]="{ expanded: isFilterCollapseExpanded(filterCollapseStateKeys.PRICE) }"
        ></div>
      </div>
      <ng-container *ngIf="(blackDealFilter$ | async)?.totalCount || (promotion$ | async)?.totalCount || (volumePrice$ | async)?.totalCount || (rebuyGuarantee$ | async)?.totalCount">
        <div class="catalog-filter__wrapper filter-wrapper" [mmTestId]="'FILTERS.PROMOTION'">
          <mm-expansion
            class="catalog-filter__wrapper__expansion"
            (toggled)="updateFilterCollapseState(filterCollapseStateKeys.PROMOTION, $event)"
            [expanded]="isFilterCollapseExpanded(filterCollapseStateKeys.PROMOTION)"
            [arrowToggler]="true"
            [testTarget]="'FILTERS.EXPANSION.TOGGLER'"
          >
            <mm-expansion-title>
              <h4 class="filter-wrapper__title">{{ 'CATALOG.CATALOG_PAGE.FILTERS.TITLE.PROMOTION' | translate }}</h4>
            </mm-expansion-title>
            <app-search-promotion-list
              [blackDeal]="blackDealFilter$| async"
              [promotion]="promotion$ | async"
              [volumePrices]="volumePrice$ | async"
              [rebuyGuarantee]="rebuyGuarantee$ | async"
              [queryParams]="queryParams"
              [isMobileOrTablet]="isMobileOrTablet"
              [isDesktop]="isDesktop"
              (blackDealFilterChanged)="filterByBlackDeals($event)"
              (promotionChanged)="filterByPromotion($event)"
              (volumePriceChanged)="filterByVolumePrice($event)"
              (rebuyGuaranteeChanged)="filterByRebuyGuarantee($event)"
            >
            </app-search-promotion-list>
          </mm-expansion>
        </div>
        <div
          class="catalog-filter__wrapper-separator"
          [ngClass]="{ expanded: isFilterCollapseExpanded(filterCollapseStateKeys.PROMOTION) }"
        ></div>
      </ng-container>

      <ng-container *ngIf="!isZeroResult">
        <div>
          <app-search-attributes-list
            (attributeFilterChanged)="filterByAttribute($event)"
            (rangeFilterChanged)="filterByAttributeRange($event)"
            (resetAttribute)="resetAttributeFilter($event)"
            [attributeFilters]="attributeFilters$ | async"
            [attributes]="attributes$ | async"
            [isBrandPLPPage]="isBrandPLPPage"
            [queryParams]="queryParams"
            [isMobile]="isMobile"
            [isDesktop]="isDesktop"
            [isTablet]="isTablet"
            [isMobileOrTablet]="isMobileOrTablet"
            [limitOption]="limitOption"
            [maxAttrOptions]="maxAttrOptions">
          </app-search-attributes-list>
        </div>
      </ng-container>
    </div>

    <div class="catalog-filters__actions">
      <button
        mm-button
        color="primary"
        [size]="'large'"
        [mmTestTarget]="'apply-filter'"
        (click)="applyAndCloseFilters()"
      >
        {{ 'CATALOG.CATALOG_PAGE.FILTERS.BUTTON.SHOW' | translate: {count: productsCount} }}
      </button>
    </div>
  </ng-container>
</div>

<ng-template #specificFilters>
  <div
    class="specific-catalog-filters catalog-filter"
    [mmTestTarget]="'filters-container'"
    [mmTestState]="(isFiltersLoading$ | async) ? 'loading' : 'loaded'"
  >
    <ng-container *ngIf="filterType?.type === 'price'">
      <app-search-price-filter (priceFilterChanged)="filterByPrice($event)"></app-search-price-filter>
    </ng-container>
    <ng-container *ngIf="filterType?.type === 'category'">
      <ng-container *ngIf="isSearchPage || isCustomPLPPage || isBrandPLPPage">
        <div class="catalog-filter__wrapper filter-wrapper" [mmTestId]="'FILTERS.CATEGORIES'">
          <app-search-categories-filters-list
            [categories]="searchResultCategories$ | async"
            [queryParams]="queryParams"
            [selectedCategoriesSlugs]="categoriesFilters$ | async"
            (selectedCategoriesChanged)="filterByCategories($event)"
          >
          </app-search-categories-filters-list>
          <button
            *ngIf="isCategoryResetButtonShown()"
            mm-button
            class="catalog-filter__wrapper__filter-reset"
            color="secondary"
            [fluid]="true"
            [size]="'small'"
            [mmTestTarget]="'reset-by-filter'"
            (click)="resetCategoryFilter()"
          >
            {{ 'CATALOG.CATALOG_PAGE.FILTERS.RESET' | translate }}
          </button>
        </div>
      </ng-container>
    </ng-container>
    <ng-container *ngIf="!isZeroResult && filterType?.type === 'attribute' && filterType?.options?.attribute">
      <app-search-attributes-list
        (attributeFilterChanged)="filterByAttribute($event)"
        (rangeFilterChanged)="filterByAttributeRange($event)"
        (resetAttribute)="resetAttributeFilter($event)"
        [attributeFilters]="attributeFilters$ | async"
        [attributes]="attributes$ | async"
        [isBrandPLPPage]="isBrandPLPPage"
        [queryParams]="queryParams"
        [isMobile]="isMobile"
        [isMobileOrTablet]="isMobileOrTablet"
        [isSpecificAttribute]="true"
        [limitOption]="limitOption"
        [maxAttrOptions]="maxAttrOptions">
      </app-search-attributes-list>
    </ng-container>
  </div>
  <div class="specific-catalog-filters__actions">
    <button
      mm-button
      color="primary"
      [size]="'large'"
      [mmTestTarget]="'apply-filter'"
      [disabled]="productsCount < 1"
      (click)="applyAndCloseSpecificFilter()"
    >
      {{ 'CATALOG.CATALOG_PAGE.FILTERS.BUTTON.SHOW' | translate: {count: productsCount} }}
    </button>
  </div>
</ng-template>
